"use client";

import { AddressWithLocation } from "@/types/location";
import { createContext, PropsWithChildren, useContext, useState } from "react";

type MapLocationContextType = {
  location: AddressWithLocation | null
  setAddressWithLocation: (addr: AddressWithLocation | null) => void;
}

const MapLocationContext = createContext<MapLocationContextType>({
  location: null,
  setAddressWithLocation: () => { },
});

export const MapLocationProvider = ({ children }: PropsWithChildren) => {
  const [currentAddress, setCurrentAddress] = useState<AddressWithLocation | null>(null)
  return <MapLocationContext.Provider value={{
    location: currentAddress,
    setAddressWithLocation: setCurrentAddress,
  }}>
    {children}
  </MapLocationContext.Provider>
};

export const useMapLocationContext = () => {
  const context = useContext(MapLocationContext);
  if (!context) {
    throw new Error(
      "useMapLocationContext must be used within a MapLocationProvider",
    );
  }
  return context;
}